import React from 'react';
import 'animate.css';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';
import { SiCodingninjas } from "react-icons/si";

const MyInfo = () => {
  return (
    <section id='myinfo'>
      <div className=" flex flex-col-reverse md:flex-col lg:flex-row items-center justify-between min-h-screen bg-gray-900 text-white p-8">
      <div className="lg:w-1/2 flex justify-center animate__animated animate__bounce ">
        <img
          className="h-[300px] lg:h-[600px] hover:scale-110 transition-transform duration-300"
          src="/myinfoAvatar.png"
          alt="Nikhil Avatar"
        />
      </div>
      <div className="lg:w-1/2 text-center lg:text-left mb-8 lg:mb-0 lg:ml-20 animate__animated animate__bounce hover:scale-110 transition-transform duration-300 ">
        <div>
          <p className="font-bold text-3xl mb-2 animate__animated animate__bounce  animate__delay-1s hover:scale-110 transition-transform duration-300">
            About :
          </p>
          <p className="font-bold text-sm mb-4 animate__animated animate__bounce  animate__delay-2s hover:scale-110 transition-transform duration-300 lg:text-lg">
            I am a final-year Computer Engineering student at R.C. Patel Institute of Technology, passionate about web development and machine learning. Proficient in languages such as Java, C++, and JavaScript, and experienced with technologies like React, Node.js, and MongoDB. I am eager to apply my skills and knowledge in a dynamic and challenging environment.
          </p>
        </div>
        <div className="mt-24 flex justify-center lg:justify-start gap-6">
          <a href="https://leetcode.com/u/NikhilBhalkar/" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-yellow-500 transition-colors duration-300">
            <SiLeetcode size={40} />
          </a>
          <a href="https://github.com/nikhilbhalkar" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-gray-400 transition-colors duration-300">
            <FaGithub size={40} />
          </a>
          <a href="https://www.linkedin.com/in/nikhil-bhalkar-6a2b67260/" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-blue-600 transition-colors duration-300">
            <FaLinkedin size={40} />
          </a>
          <a href="https://www.naukri.com/code360/profile/nikhilbhalkar" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-green-500 transition-colors duration-300">
           <SiCodingninjas size={40} />
          </a>
        </div>
      </div>
    </div>
    </section>
  );
};

export default MyInfo;
